import React from 'react'
import styled from 'styled-components'
import Card2 from './Card2'
import { InnerLayout } from './Layout'
import check from '../../Assets/img/check.svg';
// import checkDisabled from '../../Assets/img/check-disabled.svg';

const DetailCard = () => {
   return (
      <PaymentStyled id='pricing'>
         <InnerLayout>
            <div data-aos='fade-down-right'>
               <h3 className="small-heading">
               Building Tech. Building Community.
               </h3>
               <p className="c-para"> What Makes This Training Unique: It blends technical web development with ethical design thinking, empowering youth to build purposeful digital solutions for their communities.</p>
            </div>
            <div className='card-con'>
               <Card2
                  account={'Skills & Tools You’ll Gain'}
                  text={'Participants build both technical and professional skills, mastering industry-standard technologies and tools:'}
                  check={check}
                  // checkDis={checkDisabled}
                  text1={'Languages, Frameworks & Libraries: HTML, CSS, JavaScript, Git, Node, API, React, Typescript, Python, PostgreSQL, Superbase'}
                  text2={'Collaboration & Development Tools: GitHub, VS Code, Postman, Figma, Miro, Trello, Slack'}
                  text3={'Deployment Platforms: GitHub Pages, Netlify, Vercel'}
                  text4={'UI/UX Design: Wireframes, prototypes, and mockups, Accessibility and inclusive design principles, Creating intuitive interfaces, smooth navigation, and fast load times'}
                  text5={'Learners will create software applications that are designed to be accessed and used through web browsers. This includes responsive design techniques to ensure applications work well on various devices, including desktops, tablets, and smartphones.'}
                  text6={'Projects: Collaborate on real-world projects that benefit communities. Build your own web apps and websites to showcase in your portfolio.Work in teams, developing both leadership and technical skills.'}
               />
            </div>
         </InnerLayout>
      </PaymentStyled>
   )
}

const PaymentStyled = styled.section`
 .card-con {
    display: flex; /* Use flexbox for centering */
    justify-content: center; /* Center horizontally */
    align-items: center; /* Center vertically */
    padding-top: 4rem; /* Adjust top padding */
    
    /* Optional: Use max-width to control the card's maximum size */
    max-width: 1200px; 
    margin: 0 auto;
    width: 100%; /* Ensure it takes full width of the container */
    
    /* Optional: If you want to increase the width of the cards themselves */
    .card2 {
      width: 100%; /* Adjust the width of individual cards */
      max-width: 100%; /* You can set a specific width like 80% or more */
    }

    @media screen and (max-width: 689px) {
      flex-direction: column; /* Stack content on mobile */
    }
  }

  p {
    text-align: center;
  }
`

export default DetailCard
